<template>
    <div class="main-content--chat page-chat">
        <router-view></router-view>
        <app-version-checker></app-version-checker>
    </div>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex';
    import io from 'socket.io-client';
    import env from '../env';
    import {Howl, Howler} from 'howler';
    import helpers from "../helpers";
    import VersionChecker from '../common_components/VersionChecker.vue';

    export default {
        data: () => ({
            env,
            count: 1,
            socket: null,
            eventsSocket: null,
            checkInterval: null,
            previousSocketId: null,
            currentRoute: null,
            connectionLost: false,
        }),
        components: {
            appVersionChecker: VersionChecker,
        },
        computed: {
            ...mapGetters([
                'localStorageAvailable',
                'loggedIn',
                'loggedInHash',
                'channelId',
                'noConnection',
                'userData',
                'channel',
                'courses',
                'personalChats',
                'channelMembers',
                'messages',
                'mainChat',
                'techChat',
                'techChatsIds',
                'users',
                'chatsAll',
                'pinnedMessage',
            ]),
        },
        created() {
            const style = [
                'background-image: url("https://media.giphy.com/media/xTiTngMMCIt7FramOc/giphy.gif")',
                'background-size: cover',
                'color: #fff',
                'padding: 10px 20px',
                'line-height: 35px',
            ].join(';');
            console.log('%cHi there!', style);

            this.checkLocalStorageAvailable();
            if (this.localStorageAvailable && this.$router.currentRoute.name !== 'login') {
                this.$store.dispatch('whoami').then(res => {
                    this.$store.dispatch('channels').then(res => {
                        let ids = res.map(channel => channel.id);
                        this.$store.dispatch('channels', ids);
                    }, err => console.log(err));
                }, err => console.log(err));
            }

            if(this.socket) {
                let $vm = this;
                $vm.socket.on('connect', () => {
                    $vm.$store.dispatch('setNoConnection', false);
                });
            }
        },
        destroyed() {
            this.destroySocket();
            this.destroyEventsSocket();
            this.socket.emit('leave', {room: this.channelId, token: localStorage.getItem('token')});

            clearInterval(this.checkInterval);
        },
        methods: {
            ...mapMutations([
                'SET_PERSONAL_CHATS',
                'SET_CHANNEL'
            ]),

            checkLocalStorageAvailable() {
                try {
                    localStorage.setItem('t', '1');
                    localStorage.removeItem('t');
                    this.$store.dispatch('setLocalStorageAvailable', true);
                } catch (e) {
                    this.$store.dispatch('setLocalStorageAvailable', false);
                    this.$router.push({name: 'no-localstorage'});
                }
            },
            createSocket() {
                let $vm = this;

                $vm.destroySocket();

                $vm.socket = io(this.env.socket_url, {
                    transportOptions: {
                        polling: {
                            extraHeaders: {
                                'token': localStorage.getItem('token')
                            }
                        }
                    }
                });

                if(this.socket) {
                    $vm.socket.emit('join', {room: $vm.channelId, token: localStorage.getItem('token')});
                }

                $vm.socket.on('my response', (msg) => {
                    console.log(msg.data, "my response");

                    if(this.techChatsIds.some(el => el === this.channelId)) {
                        let studentGroupsIds = msg.data.student_groups_ids ? msg.data.student_groups_ids.split(',') : [],
                            userGroups = [];

                        Object.entries(this.userData.students_groups).forEach(group => {
                            userGroups.push(group[1].id);
                        });

                        if(!studentGroupsIds.some(id => userGroups.some(group => +id === +group))
                            && (this.userData.role !== 'admin' && this.userData.role !== 'moderator' && this.userData.role !== 'teacher')) return;
                    }

                    let typingMember = $vm.channelMembers[msg['user_id']];
                    let messageToAdd = msg.data.message,
                        whiteboard = {
                            id: null,
                        };

                    if(messageToAdd) {
                        whiteboard.id = msg.data.whiteboard;
                        messageToAdd['whiteboard'] = whiteboard;
                        messageToAdd['student_groups_ids'] = msg.data.student_groups_ids;
                    }

                    $vm.$store.dispatch('addMessageToChannel', messageToAdd);

                    if (msg.data.uploadedFile) {
                        $vm.$store.commit("SET_FOR_COMPONENT", {
                            page: 'mainChat',
                            field: 'sentFile',
                            value: {
                                hash: msg.data.msgHash,
                                id: msg.data.message.id
                            }
                        });

                        let params = {loader: true, chatMessageId: msg.data.message.id};
                        $vm.$store.dispatch('fileLoader', params);
                    }

                    this.$store.dispatch('scrollChatSection');

                    const mainChatSection = document.getElementById("main-chat-section"),
                        mainChat = document.getElementById('mainChat');

                    if (mainChatSection !== null && mainChat !== null) {
                        if (Math.floor(mainChatSection.scrollTop + mainChatSection.clientHeight) === mainChat.clientHeight
                            || Math.ceil(mainChatSection.scrollTop + mainChatSection.clientHeight) === mainChat.clientHeight) {

                            $vm.$store.dispatch('setAllMessagesRead', {'channel_id': $vm.channelId, 'lang': localStorage.getItem('language')});

                        } else if (typeof msg.data['sender_data'] !== 'undefined' && $vm.userData.id !== msg.data['sender_data'].id) {
                            $vm.$store.commit("SET_FOR_COMPONENT", {
                                page: 'mainChat',
                                field: 'scrollButton',
                                value: true
                            });
                        }
                    }

                });

                $vm.socket.on('edit_message_response', msg => {
                    console.log(msg.data, "edit_message_response");
                    let messages = $vm.messages;
                    messages[msg.data.message_id]['text'] = msg.data.text;
                    messages[msg.data.message_id]['edited'] = true;
                    messages[msg.data.message_id]['student_groups_ids'] = msg.student_groups_ids;
                    this.$store.commit('SET_MESSAGES', messages);
                    if(this.pinnedMessage.messageId === msg.data.message_id) {
                        let data = {
                            messageId: msg.data.message_id,
                            text: msg.data.text,
                            pin: true,
                            author: {
                                first_name: this.pinnedMessage.author.first_name,
                                last_name: this.pinnedMessage.author.last_name,
                                patronymic: this.pinnedMessage.author.patronymic,
                            },
                            created: this.pinnedMessage.created
                        }
                        this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'pinnedMessage', value: data});
                    }
                });

                $vm.socket.on('pin message event', msg => {
                    console.log(msg, "pin message event");
                    this.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'pinnedMessage', value: msg.data});
                });

                $vm.socket.on('is_online', (msg) => {
                    let chats = this.personalChats;
                    console.log(msg.data.user_id, "user_id");
                    chats.forEach(item => {
                        item.members.forEach(el => {
                            if (el.id === msg.data.user_id) {
                                el.is_online = msg.data.status
                            }
                        })
                    });
                    chats = helpers.getUnique(chats, 'id');
                    this.SET_PERSONAL_CHATS(chats);

                    let users = this.users;
                    users.forEach(user => {
                        if(user.id === msg.data.user_id) {
                            user.is_online = msg.data.status
                        }
                    });
                    this.$store.commit('SET_USERS', users);

                    if (this.channel !== null) {
                        let channel = this.channel,
                            members = channel.members;

                        if (!Object.keys(members).length == 0) {
                            Object.entries(members).forEach(item => {
                                if (item[1].id === msg.data.user_id) {
                                    item[1].is_online = msg.data.status;
                                }
                            })
                        }
                        this.SET_CHANNEL(channel);
                    }
                });

                $vm.socket.on('connect_error', () => {
                    $vm.$store.dispatch('setNoConnection', true);
                });
                $vm.socket.on('connect_timeout', () => {
                    $vm.$store.dispatch('setNoConnection', true);
                });
                $vm.socket.on('reconnect', () => {
                    window.location.reload(true);
                    $vm.$store.dispatch('setNoConnection', false);
                    if(this.socket) $vm.socket.emit('join', {room: $vm.channelId, token: localStorage.getItem('token')});
                });
            },
            createEventsSocket() {
                let $vm = this;
                $vm.eventsSocket = io(this.env.socket_url, {
                    transportOptions: {
                        polling: {
                            extraHeaders: {
                                'token': localStorage.getItem('token')
                            }
                        }
                    }
                });

                $vm.eventsSocket.on('connect', () => {
                    this.eventsSocket.emit('join', {
                        room: 'events_school_' + this.userData.school_id,
                        token: localStorage.getItem('token')
                    });
                    console.log("created events socket");
                });

                $vm.eventsSocket.on('new_unread_message', (msg) => {
                    console.log(msg.data, "new_unread_message");

                    Howler.autoUnlock = false;
                    let sound = new Howl({
                        src: ['/static/front-end/public/assets/sound/sound.mp3'],
                        autoUnlock: true,
                        onplayerror: function() {
                            sound.once('unlock', function() {
                                sound.play();
                            });
                        }
                    });

                    if(this.userData.id !== msg.data.sender_id && this.chatsAll.some(i => i.id === msg.data.channel_id)){
                        sound.play();
                    }

                    if(msg.data.student_groups_ids && msg.data.student_groups_id !== '') {

                        let studentGroupsIds = msg.data.student_groups_ids ? msg.data.student_groups_ids.split(',') : [],
                            userGroups = [];

                        Object.entries(this.userData.students_groups).forEach(group => {
                            userGroups.push(group[1].id);
                        });

                        if(!studentGroupsIds.some(id => userGroups.some(group => +id === +group))) return;
                    }

                    if (+msg.data.channel_id !== $vm.channelId) {
                        $vm.$store.dispatch('updateChannelUnreadCounter', msg.data);
                    }

                    if(msg.data.delivery && msg.data.members.some(i => i.userprofile_id === $vm.userData.id) && +msg.data.channel_id !== $vm.channelId) {
                        let sender = msg.data.sender,
                            personalChats = this.personalChats,
                            hasChannel = personalChats.some(chat => chat.members.some(member => member.id === sender.id)),
                            hasChannelDummy = personalChats.some(chat => chat.members.some(member => member.id === sender.id) && chat.dummy);

                        sender.photo = location.origin + '/media/' + sender.photo;
                        let model = {
                            id: sender.id,
                            name: "",
                            icon: null,
                            is_group: false,
                            is_tech: false,
                            unread_messages_count: this.count,
                            members: [sender],
                            last_msg_datetime: 9999999999,
                            category: null,
                            dummy: true,
                        };
                        this.count++;
                        personalChats.unshift(model);
                        personalChats = helpers.getUnique(personalChats, 'id');
                        console.log(personalChats, "1");
                        if(hasChannel && !hasChannelDummy) {
                            personalChats = personalChats.filter(chat => !chat.members.some(member => member.id === sender.id && chat.dummy));
                        }
                        console.log(personalChats, "2");

                        this.$store.commit('SET_PERSONAL_CHATS', personalChats);
                    }
                    // $vm.$store.dispatch('updatePersonalChats', msg.data);
                    $vm.$store.dispatch('updatePersonalChats', msg.data);
                });

                $vm.eventsSocket.on('channel_updated', (msg) => {
                    let courses = $vm.courses,
                        msgData = JSON.parse(msg.data.channel),
                        personalChats = $vm.personalChats;
                    console.log(msgData, "channel updated ");

                    courses = courses.filter(item => item.id !== msgData.id);
                    courses.unshift(msgData);
                    courses.sort((a, b) => (a.id > b.id) ? 1 : -1);
                    $vm.$store.commit('SET_COURSES', courses);

                    if (msgData.id == $vm.channelId) {
                        $vm.SET_CHANNEL(msgData);
                    }

                    if(!msgData.is_group && msgData.members.some(i => i.id === $vm.userData.id)) {
                        msgData.members = msgData.members.filter(i => i.id !== $vm.userData.id);
                        personalChats.push(msgData);
                        personalChats = helpers.getUnique(personalChats, 'id');
                        $vm.SET_PERSONAL_CHATS(personalChats);
                    }

                    if (!msgData.members.some(item => item.id == $vm.userData.id)
                        && $vm.$route.path == `/channel/${msgData.id}`) {
                        $vm.$router.push({name: 'dashboard'})
                    }
                });

                $vm.eventsSocket.on('user_profile_photo_updated', function (msg) {

                    let chats = $vm.personalChats,
                        response = JSON.parse(msg.data.user);

                    chats.forEach(item => {
                        item.members.forEach(member => {
                            if (member.id === response.id) {
                                member.photo = response.photo;
                            }
                        })
                    });

                    let channel = $vm.channel;
                    if(channel !== null) {
                        channel.members.forEach(item => {
                            if (item.id === response.id) {
                                item.photo = response.photo;
                            }
                        });
                        $vm.SET_CHANNEL(channel);
                    }

                    if (response.id === $vm.userData.id) {
                        $vm.$store.commit('SET_USER_PHOTO', response.photo)
                    }

                    chats = helpers.getUnique(chats, 'id');
                    $vm.$store.commit('SET_PERSONAL_CHATS', chats)
                });

                $vm.eventsSocket.on('attachment_uploaded', function (msg) {
                    const msgData = JSON.parse(msg.data.attachment),
                        messageId = msg.data.chat_message_id;
                    console.log(msgData, "msgData");

                    let messages = $vm.messages;

                    if(Object.keys(messages).length !== 1) {
                        messages[messageId]['attachment'] = msgData;

                        $vm.$store.commit('SET_MESSAGES', messages);
                        $vm.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'key', value: $vm.mainChat.key + 1});
                        $vm.$store.commit("SET_FOR_COMPONENT", {page: 'mainChat', field: 'isUploaded', value: false});
                        let params = {loader: false, chatMessageId: messageId};
                        $vm.$store.dispatch('fileLoader', params);
                    }

                });
            },
            destroySocket() {
                if (this.socket) {
                    this.socket.emit('leave', {room: this.previousSocketId, token: localStorage.getItem('token')});
                }
            },
            destroyEventsSocket() {
                if (this.eventsSocket) {
                    this.eventsSocket.emit('join', {
                        room: 'events_school_' + this.userData.school_id,
                        token: localStorage.getItem('token')
                    });
                }
            },
        },
        watch: {
            '$route'(to, from) {
                if(this.previousSocketId !== this.channelId) {
                    this.previousSocketId = this.channelId
                }
                this.currentRoute = this.$route.name;

                let body = document.querySelector('body');
                this.$route.name === 'login' ? body.classList.add('page-body--login') : body.classList.remove('page-body--login');
            },
            'userData'(val) {
                if(val){
                    this.createSocket();
                    this.createEventsSocket();
                }
            },
            'channelId'(val) {
                let $vm = this;
                if(val && $vm.socket){
                    this.destroySocket();
                    $vm.socket.emit('join', {room: $vm.channelId, token: localStorage.getItem('token')});
                }
            },
        },
    }
</script>

<style lang="sass">
    @import "../../sass/app"
</style>
